// Téléchargement d'un export (CSV/XLS) via une requête authentifiée (blob).
import api from "@/lib/api";

export async function telechargerExport(url, params, format, nomBase) {
  const res = await api.get(url, { params: { ...params, format }, responseType: "blob" });
  const blobUrl = URL.createObjectURL(res.data);
  const ext = format === "xls" ? "xlsx" : format === "pdf" ? "pdf" : "csv";
  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = `${nomBase}.${ext}`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(blobUrl);
}
